import { useEffect, useState } from "react";

export function useOptimistic<T>(item: T) {
	/** State */
	const [state, setState] = useState<T>(item);

	/** Effects */
	useEffect(() => {
		setState(item);
	}, [item]);

	/** Functions */
	async function updateFn(fn: (state: T) => T) {
		const newState = fn(state);
		setState(newState);
	}

	/** Return */
	return { state, updateFn };
}

export type OptimisticUpdateFn<T> = ReturnType<typeof useOptimistic<T>>["updateFn"];
